<template>
  <div>
    <!-- Form Busca -->
    <b-row :style="tituloRowBG" class="tituloPaginaRow">
      <h1 class="tituloPagina">
        {{ tituloPagina }}
      </h1>
    </b-row>
    <b-row class="p-3 p-sm-0 p-md-0 p-lg-0 p-xl-0">
      <b-form
        id="formBusca"
        @keyup.enter="search()"
        @reset="onResetSearch"
        class="mb-0"
      >
        <p v-if="client === 'DOE-AL'">
          Realize sua busca, utilizando o critério desejado. Para isso, preencha
          qualquer um dos campos abaixo.
        </p>
        <p v-else>
          Busque as edições publicadas com o critério desejado preenchendo os
          campos abaixo.
        </p>
        <b-row>
          <!-- imagem busca mobile  -->
          <b-col cols="12" class="d-sm-inline-block d-md-none px-4 text-center">
            <img
              class="w-75"
              src="../assets/imagens/homeDiarioBusca.png"
              alt="Imagem de busca nas edições"
            />
          </b-col>
          <!-- form -->
          <b-col cols="12" md="10">
            <!-- Palavra -->
            <b-row>
              <b-col cols="12">
                <b-form-group id="inputGrupoPalavraChave">
                  <b-form-input
                    id="inputPalavraChave"
                    type="text"
                    v-model="formBusca.keywords"
                    placeholder="Buscar por: (Qualquer palavra...)"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <!-- Período inicial -->
              <b-col cols="12" sm="6" md="4">
                <b-form-group
                  id="inputGrupoPeriodoInicial"
                  label="Período inicial:"
                  label-for="inputPeriodoInicial"
                >
                  <b-form-input
                    id="inputPeriodoInicial"
                    type="date"
                    v-model="periodo_inicial"
                    placeholder="Período inicial ..."
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <!-- Período final -->
              <b-col cols="12" sm="6" md="4">
                <b-form-group
                  id="inputGrupoPeriodoFinal"
                  label="Período final:"
                  label-for="inputPeriodoFinal"
                >
                  <b-form-input
                    id="inputPeriodoFinal"
                    type="date"
                    v-model="periodo_final"
                    placeholder="Período final ..."
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <!-- Número edição -->
              <b-col cols="12" sm="6" md="4">
                <b-form-group
                  id="inputGrupoNumeroEdicao"
                  label="Número da Edição:"
                  label-for="inputNumeroEdicao"
                >
                  <b-form-input
                    id="inputNumeroEdicao"
                    type="text"
                    v-model="formBusca.edition_number"
                    placeholder="Edição Nº..."
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
          <!-- imagem busca  -->
          <b-col
            cols="12"
            sm="2"
            md="2"
            lg="2"
            xl="2"
            class="d-none d-md-inline-block pt-2"
          >
            <img
              class="img-fluid"
              src="../assets/imagens/homeDiarioBusca.png"
              alt="Imagem de busca nas edições"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-row>
              <!-- Select Tipo de busca -->
              <b-col cols="12" sm="5">
                <b-form-group
                  id="selectGrupoBuscaTipo"
                  label="Buscar por:"
                  label-for="selectBuscaTipo"
                >
                  <v-select
                    id="selectBuscaTipo"
                    placeholder="Selecione o tipo da busca"
                    label="title"
                    v-model="formBusca.searchType"
                    :options="searchTypeOptions"
                  >
                  </v-select>
                </b-form-group>
              </b-col>
              <!-- Select Ordem -->
              <b-col cols="12" sm="5">
                <b-form-group
                  id="selectGrupoOrdenacao"
                  label="Ordenar por:"
                  label-for="selectOrdenacao"
                >
                  <v-select
                    id="selectOrdenacao"
                    placeholder="Selecione a ordenação da busca"
                    label="title"
                    v-model="formBusca.order"
                    :options="orderOptions"
                  >
                  </v-select>
                </b-form-group>
              </b-col>
              <!-- Botoes -->
              <b-col cols="12" sm="10" class="pt-4 pl-0">
                <b-form-group class="float-right">
                  <b-button class="mt-2 mr-1" type="reset" variant="cinzaClaro">
                    Limpar
                  </b-button>
                  <b-button
                    class="mt-2"
                    type="button"
                    @click="search()"
                    variant="primary"
                  >
                    Buscar
                  </b-button>
                </b-form-group>
              </b-col>
              <b-col
                cols="2"
                class="pt-4 pl-0 d-none d-sm-inline-block"
              ></b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-form>
    </b-row>
    <!-- Resultados -->
    <template>
      <transition name="fade" mode="in-out">
        <b-row v-show="showSearching" class="mt-4" style="height: 100vh">
          <b-col cols="12">
            <h1 class="tituloPagina">
              Buscando por
              <span class="palavraResultado">{{ resultKeywords }}</span>
              <span v-show="periodo_inicial">
                no período de
                <strong>{{ periodo_inicial | formatDate }}</strong>
              </span>
              <span v-show="periodo_final">
                até <strong>{{ periodo_final | formatDate }}</strong>
              </span>
              ...
            </h1>
          </b-col>
        </b-row>
      </transition>

      <transition name="fade" mode="in-out">
        <b-row
          :style="tituloRowBG"
          v-show="showResults"
          id="areaResultados"
          class="mt-4 tituloPaginaRow"
        >
          <h1 class="tituloPagina">
            {{ tituloResultado }}
          </h1>
        </b-row>
      </transition>

      <transition name="fade" mode="in-out">
        <b-row v-show="showResults" class="p-3 p-sm-0 p-md-0 p-lg-0 p-xl-0">
          <p>
            Exibindo <strong>{{ totalRows }}</strong> resultados para a consulta
            <span class="palavraResultado">{{ resultKeywords }}</span>
            <span v-show="periodo_inicial">
              no período de
              <strong>{{ periodo_inicial | formatDate }}</strong>
            </span>
            <span v-show="periodo_final">
              até <strong>{{ periodo_final | formatDate }}</strong>
            </span>
          </p>
        </b-row>
      </transition>
      <transition name="fade" mode="in-out">
        <b-row v-show="showResults">
          <!-- Filtros resultados -->
          <b-col cols="12" sm="3">
            <div id="filtrosResultados" class="block">
              <b-form-group label="Veículo de Publicação">
                <b-form-checkbox-group
                  stacked
                  id="filtroVeiculo"
                  name="flavour2"
                  :options="filtroVeiculo"
                  v-model="filtroVeiculoSelected"
                  @change="changeFilters()"
                >
                </b-form-checkbox-group>
              </b-form-group>
              <b-form-group label="Tipo de Edição">
                <b-form-checkbox-group
                  stacked
                  id="filtroTipoEdicao"
                  name="flavour2"
                  :options="filtroTipoEdicao"
                  v-model="filtroTipoEdicaoSelected"
                  @change="changeFilters()"
                >
                </b-form-checkbox-group>
              </b-form-group>
              <b-form-group label="Ano de Publicação">
                <b-form-checkbox-group
                  stacked
                  id="filtroAnoPublicacao"
                  name="flavour2"
                  :options="filtroAnoPublicacao"
                  v-model="filtroAnoPublicacaoSelected"
                  @change="changeFilters()"
                >
                </b-form-checkbox-group>
              </b-form-group>
              <b-row class="text-center">
                <b-col cols="12">
                  <b-button
                    @click="clearFilters()"
                    type="button"
                    variant="primary"
                    :disabled="disableClearFilters"
                  >
                    Redefinir filtros
                  </b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <!-- Área dos items -->
          <b-col cols="12" sm="9">
            <div v-for="(item, index) in items" :key="index">
              <buscaItem :item="item" :result="resultKeywords"></buscaItem>
            </div>
            <nav class="paginationNav">
              <b-pagination
                :total-rows="totalRows"
                :per-page="perPage"
                v-model="currentPage"
                @input="changePage"
                prev-text="Anterior"
                next-text="Próximo"
                hide-goto-end-buttons
              />
            </nav>
          </b-col>
        </b-row>
      </transition>
    </template>
  </div>
</template>

<script>
  import moment from 'moment'
  import 'moment/locale/pt-br'
  import vSelect from 'vue-select'
  import buscaItem from './BuscaItem'
  import PortalApi from '@/api/portal'
  import client from '@/main.js'

  export default {
    name: 'BuscaAvancada',
    components: {
      vSelect,
      buscaItem
    },
    data() {
      return {
        client: null,
        totalRows: 0,
        perPage: 15,
        currentPage: 1,
        min_date: '',
        max_date: '',
        items: [],
        tituloPagina: 'Pesquisar Edições',
        tituloResultado: 'Resultados da Busca',
        showResults: false,
        showSearching: false,
        resultOffset: 0,
        resultKeywords: '',
        periodo_inicial: '',
        periodo_final: '',
        searchTypeOptions: [
          { title: 'Todas as palavras', value: 'toda_palavra' },
          { title: 'Frase exata', value: 'frase_exata' },
          { title: 'Qualquer palavra', value: 'qualquer_palavra' }
        ],
        orderOptions: [
          { title: 'Mais antiga', value: 'antigo' },
          { title: 'Mais nova', value: 'novo' },
          { title: 'Por relevância', value: 'relevancia' }
        ],
        formBusca: {
          keywords: '',
          range: [],
          edition_number: '',
          searchType: {
            title: 'Frase exata',
            value: 'frase_exata'
          },
          order: {
            title: 'Mais nova',
            value: 'novo'
          }
        },
        filtroVeiculo: [],
        filtroVeiculoSelected: [],
        filtroTipoEdicao: [],
        filtroTipoEdicaoSelected: [],
        filtroAnoPublicacao: [],
        filtroAnoPublicacaoSelected: [],
        disableClearFilters: true
      }
    },
    created() {
      let me = this
      me.client = client.CLIENT
      me.tituloRowBG = {
        backgroundImage:
          'url(' +
          require('@/assets/imagens/' + me.client + '/tituloPagFdo.png') +
          ')'
      }
    },
    mounted() {
      this.loadDataSearch()
    },
    methods: {
      loadDataSearch() {
        let me = this
        let searchData = this.$store.state.searchData
        if (typeof searchData.palavra_chave === 'undefined') return false
        me.formBusca.keywords = searchData.palavra_chave
        me.periodo_inicial = searchData.periodo_inicial
        me.periodo_final = searchData.periodo_final
        me.formBusca.edition_number = searchData.edition_number
        me.formBusca.searchType = searchData.searchType
        me.formBusca.order = searchData.order

        me.fetchEditions()
        me.showResults = true
        // limpando store
        me.$store.commit('populateSearch', null)
      },
      getResultTop() {
        let resultArea = document.getElementById('areaResultados')
        this.resultOffset = resultArea.offsetTop
      },
      scrollTop() {
        let timeOut
        let me = this
        if (
          document.body.scrollTop > me.resultOffset ||
          document.documentElement.scrollTop > me.resultOffset
        ) {
          window.scrollBy(0, -30)
          timeOut = setTimeout(me.scrollTop, 10)
        } else clearTimeout(timeOut)
      },
      changePage() {
        this.getResultTop()
        this.fetchEditions(this.currentPage)
        this.scrollTop()
      },
      onResetSearch(evt) {
        evt.preventDefault()
        /* Limpar os campos do formulario */
        this.formBusca.keywords = ''
        this.periodo_inicial = ''
        this.periodo_final = ''
        this.formBusca.edition_number = ''
        this.formBusca.searchType = 'frase_exata'
        this.formBusca.order = 'novo'
        this.showResults = false
        this.showSearching = false
      },
      clearFilters() {
        /* Limpar os campos do filtro */
        this.filtroVeiculoSelected = []
        this.filtroTipoEdicaoSelected = []
        this.filtroAnoPublicacaoSelected = []
        this.showSearching = false
        this.search()
      },
      changeFilters() {
        if (
          this.filtroVeiculoSelected.length ||
          this.filtroTipoEdicaoSelected.length ||
          this.filtroAnoPublicacaoSelected.length
        ) {
          this.disableClearFilters = false
        } else {
          this.disableClearFilters = true
        }
        this.search()
      },
      search() {
        this.currentPage = 1
        this.showResults = false
        this.fetchEditions()
      },
      fetchEditions(page = 1) {
        let me = this

        me.showSearching = true
        me.formBusca.range = [me.periodo_inicial, me.periodo_final]
        me.resultKeywords = me.formBusca.keywords

        let dataBusca = {
          keywords: me.formBusca.keywords,
          range: me.formBusca.range,
          edition_number: me.formBusca.edition_number,
          searchType: '',
          order: ''
        }

        dataBusca.searchType =
          me.formBusca.searchType && me.formBusca.searchType.value
            ? me.formBusca.searchType.value
            : 'frase_exata'
        dataBusca.order =
          me.formBusca.order && me.formBusca.order.value
            ? me.formBusca.order.value
            : 'novo'

        if (me.filtroVeiculoSelected.length) {
          dataBusca.edition_type_name = me.filtroVeiculoSelected[0]
        }

        if (me.filtroTipoEdicaoSelected.length) {
          dataBusca.is_suplement = me.filtroTipoEdicaoSelected[0]
        }

        if (me.filtroAnoPublicacaoSelected.length) {
          dataBusca.filter_year = me.filtroAnoPublicacaoSelected[0]
          // dataBusca.filter_year = me.filtroAnoPublicacaoSelected
        }

        const promise = PortalApi.searchEditions(page, dataBusca)

        promise.then((data) => {
          me.totalRows = data.total_rows.value
          me.min_date = data.min_date
          me.max_date = data.max_date
          me.items = data.items
          me.filtroVeiculo = data.edition_type_name
          me.filtroTipoEdicao = data.is_suplement
          me.filtroAnoPublicacao = data.filter_year

          me.showResults = true
          me.showSearching = false
        })
      }
    },
    filters: {
      formatDate: function (value) {
        if (value) {
          return moment(String(value)).format('LL')
        }
        return '-'
      }
    }
  }
</script>

<style lang="scss">
  @import '../assets/scss/estilos.scss';
  #formBusca {
    width: 100%;
  }
  .palavraResultado {
    color: $corPrimaria;
    font-weight: bold;
  }
  #filtrosResultados {
    .col-form-label {
      font-size: 15px;
      font-weight: 500;
      margin-bottom: 0;
    }
    .custom-control {
      margin-left: 0.75rem;
    }
    .custom-control-label {
      font-size: 14px;
      font-weight: normal;
    }
    a.show-more {
      color: $corFontePadrao;
      padding-left: 0.75rem;
      &:hover .fa-icon {
        color: $corPrimariaClara;
      }
      .fa-icon {
        margin-bottom: -3px;
      }
      span {
        margin-left: 0.25rem;
        font-size: 14px;
        color: $corTextoInput;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Busca.vue